import React, { useEffect, useState } from "react";
import Accordion from "../../component/global/accordion";
import Drawer from "../../component/global/drawer";
import ViewConfig from "../../config/viewConfig";
import ModalContent from "../../component/global/modal";
import CardCarousel from "../../component/global/cardCarousel";
import { baseUrl, loadData } from "../../config/data";
import AutoResizeTextArea from "../../component/layout/text_area";
import { useDrawerTransition } from "../../context/drawerProvider";
import '../../index.css'
import JobDrawer from "../../component/global/jobDrawer";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import CircleEffect from "../../component/global/circleEffect";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";
import Swal from "sweetalert2";

const Home = ({ }) => {
    const dispatch = useDispatch();
    const { lang } = useSelector((state) => state.globalReducer);
    const { language } = useParams();
    const localStatus = localStorage?.getItem('showModal');
    const [isModalOpen, setModalOpen] = useState(true);
    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);
    const [keywords, setkeywords] = useState('');
    const [jobListData, setJobListData] = useState([]);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerTitle, setDrawerTitle] = useState('Menu');
    const [jobData, setJob] = useState({});
    const [blogData, setBlogData] = useState([]);
    const [lengthBlogData, setlengthBlogData] = useState(0);
    const mobileView = ViewConfig();
    const { startTransition } = useDrawerTransition();

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const loadBlogata = async () => {
        loadData({
            url: `Blogs`,
            params: [{ title: 'limit', value: 3 }, { title: 'page', value: 0 }, { title: 'filter', value: 'status:Published' }],
        }).then(async res => {
            if (res?.data) {
                setBlogData(res.data);
                setlengthBlogData(res?.total);
            }
        })
    };

    useEffect(() => {
        loadJobata();
        loadBlogata();
    }, [])

    const loadJobata = async () => {
        const now = new Date();
        const formattedDate = now.toISOString().split("T")[0].slice(0, 10);
        loadData({
            url: `Jobs`,
            params: [{ title: 'date', value: formattedDate }, { title: 'limit', value: 3 }, { title: 'page', value: 0 }],
        }).then(async res => {
            if (res?.data) {
                const resData = res?.data;
                const simplifiedJobs = resData.map(job => ({
                    job: job,
                    jobID: job.jobID,
                    title: job.jobTitle,
                    tags: [job?.location, job?.jobType, job?.department],
                    jobDescription: job.jobDescription,
                    jobDescription_Id: job.jobDescription_Id,
                }));
                setJobListData(simplifiedJobs)
            }
        })
    };

    const [currentSlide, setCurrentSlide] = useState(0);

    const arrIntro = [
        { label: Lang(lang, 'life_at_sopra'), image: '/asset/demo1.webp', description: `"${Lang(lang, 'intro_desc_1')}"` },
        { label: Lang(lang, 'intro_title_2'), image: '/asset/demo2.webp', description: `"${Lang(lang, 'intro_desc_2')}"` },
        { label: Lang(lang, 'intro_title_3'), image: '/asset/demo3.webp', description: `"${Lang(lang, 'intro_desc_3')}"`, sub_desc: Lang(lang, 'intro_subDesc_3') }
    ];

    const arrBenefit = [
        { label: Lang(lang, 'benefit_title_1'), image: '/asset/Career_Growth.webp', description: Lang(lang, 'benefit_desc_1') },
        { label: Lang(lang, 'benefit_title_2'), image: '/asset/Supportive.webp', description: Lang(lang, 'benefit_desc_2') },
        { label: Lang(lang, 'benefit_title_3'), image: '/asset/Culture.webp', description: Lang(lang, 'benefit_desc_3') },
        { label: Lang(lang, 'benefit_title_4'), image: '/asset/Engagement.webp', description: Lang(lang, 'benefit_desc_4') }
    ];

    const arrComment = [
        { message: Lang(lang, 'testimony_desc_1'), author: Lang(lang, 'testimony_title_1') },
        { message: Lang(lang, 'testimony_desc_2'), author: Lang(lang, 'testimony_title_2') },
        { message: Lang(lang, 'testimony_desc_3'), author: Lang(lang, 'testimony_title_3') },
        { message: Lang(lang, 'testimony_desc_4'), author: Lang(lang, 'testimony_title_4') },
        { message: Lang(lang, 'testimony_desc_5'), author: Lang(lang, 'testimony_title_5') },
        { message: Lang(lang, 'testimony_desc_6'), author: Lang(lang, 'testimony_title_6') },
    ]

    const renderModal = () => {
        return (
            <ModalContent isOpen={isModalOpen} backgroundImage={'white'} onClose={() => {
                closeModal();
                localStorage?.setItem('showModal', false);
            }} position={"center"} title={``} setWidth={mobileView ? "80%" : "35%"} setHeight="auto" maxWidth={'512px'} isWarning={false} >
                <div className="flex items-start p-4">
                    <div className="flex flex-col gap-4 items-center w-full">
                        <div className='w-[28%] mx-auto mt-10'>
                            <img src="/asset/logosopra_high.png" />
                        </div>
                        <p className="text-[16px] text-[#4B5563]">{Lang(lang, 'sign_in_desc')}</p>
                        <div className="mb-4 w-full">
                            <label htmlFor="email" className="text-sm text-gray-700 font-medium mb-1 block">
                                Email address
                            </label>
                            <div className={`relative w-full`}>
                                <img
                                    src="/asset/icon/email.svg"
                                    alt="email"
                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                                />
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm ${errors.email ? "border-red-500" : "border-[#48494B]"}`}
                                />
                            </div>
                        </div>
                        <div className="mb-4 w-full">
                            <label htmlFor="password" className="text-sm text-gray-700 font-medium mb-1 block">
                                Password
                            </label>
                            <div className="relative">
                                <img
                                    src="/asset/icon/password.svg"
                                    alt="password"
                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                                />
                                <input
                                    type="password"
                                    id="password"
                                    placeholder="Enter your password"
                                    className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm ${errors.password ? "border-red-500" : "border-[#48494B]"}`}
                                />
                                {/* Optional: Password visibility toggle icon */}
                                <img
                                    src="/asset/icon/eye.svg"
                                    alt="show"
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between items-center text-sm mb-6 w-full">
                            <label className="flex items-center space-x-2">
                                <input type="checkbox" className="form-checkbox text-red-500" />
                                <span className="text-gray-700">Remember me</span>
                            </label>
                        </div>

                        <button className="w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-2 rounded-full">
                            Sign in
                        </button>

                        {/* <p className="text-center text-sm text-gray-600 mt-6">
                            Don’t have an account?{' '}
                            <a href="#" className="text-red-500 font-medium hover:underline">
                                Sign up here
                            </a>
                        </p> */}
                    </div>
                    <div className="hidden md:flex flex-row items-center gap-1 cursor-pointer  absolute right-4" onClick={() => closeModal()}>
                        <img src={"/asset/icon/close.svg"} />
                    </div>
                </div>
            </ModalContent>
        )
    }

    return (<>
        <div className="pt-8" data-aos="fade-in">
            <p className='text-[#48494B] text-[32px] md:text-[84px] w-[80%] md:w-full mx-auto font-normal leading-tight text-center'>{Lang(lang, 'home_title1') + ' '}<b className='text-[#034694] font-semibold'>{Lang(lang, 'home_title2')}</b> {Lang(lang, 'at')} <b className='text-[#EA2427] font-semibold'>SOPRA</b></p>
            <div className="w-[80%] md:w-[50%] 2xl:w-[38%] mx-auto pt-12 max-w-[1000px]">
                <div className='relative'>
                    <div className="absolute inset-y-0 start-0 flex items-center ps-6 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>

                    <input
                        type="search"
                        id="default-search"
                        className="block w-full p-3 md:p-4 ps-14 md:ps-14 pe-12 md:pe-16 text-sm md:text-base text-gray-900 border border-gray-300 rounded-[35px] bg-[#FFFFFF]"
                        placeholder={Lang(lang, 'search_job_hint_footer')}
                        required
                        style={{ boxShadow: '0px 0px 15px 2px rgba(0, 118, 255, 0.15)' }}
                        onChange={(e) => {
                            setkeywords(e.target.value);
                        }}
                        onKeyUp={(e) => {
                            if (e.key === "Enter" && keywords) {
                                startTransition(`/${lang}/portal?search=${keywords}`);
                            }
                        }}
                    />
                    {/* <button type="submit" className="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Search</button> */}
                    <div className='absolute end-2 bottom-[8px] md:bottom-1.5' onClick={() => {
                        startTransition(`/${lang}/portal?search=${keywords}`);
                    }}>
                        <img src="/asset/submitBtn.png" className="w-[30px] h-[30px] md:w-[45px] md:h-[45px]" />
                    </div>
                </div>
            </div>
        </div>

        <div className="pt-8 flex flex-col gap-6 w-[80%] md:w-[75%] max-w-[1180px] mx-auto" data-aos="fade-left">
            {arrIntro?.map((val, idx) => (
                <div key={idx} className={`rounded-[20px] md:rounded-[30px] flex min-h-0 md:min-h-[400px] bg-white flex-col ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} style={{ boxShadow: '0px 0px 6px 2px rgb(0 118 255 / 15%)' }}>
                    <div className={`${idx % 2 === 0 ? 'rounded-ss-[20px] md:rounded-ss-[30px] rounded-se-[20px] md:rounded-se-[0px] md:rounded-es-[30px] md:rounded-ee-0' : 'rounded-se-[20px] rounded-ee-[0px] md:rounded-ee-[30px] rounded-ss-[20px] md:rounded-ss-[0px]'} bg-slate-600 w-full md:w-[50%] h-auto min-h-[220px] md:min-h-[592px]`} style={{ backgroundImage: `url(${val?.image})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundColor: 'white', backgroundPosition: `${mobileView ? 'top' : 'center'}` }} />
                    <div className="flex flex-col justify-center gap-2 md:gap-4 py-4 md:py-6 m-auto w-[85%] md:w-[40%]">
                        <p className={idx % 2 === 0 ? "text-[20px] md:text-[30px] font-bold text-[#034694]" : "text-[20px] md:text-[30px] font-bold text-[#EA2427]"}>{val?.label}</p>
                        <p className="font-normal md:font-medium text-sm md:text-xl">{val?.description}</p>
                        {val?.sub_desc && <p className="font-semibold md:font-semibold text-sm md:text-xl">{val?.sub_desc}</p>}
                    </div>
                </div>
            ))}
        </div>

        <div className="pt-16 md:pt-28 flex flex-col md:flex-row mx-auto gap-6 w-full relative" data-aos="fade-right" style={{ backgroundImage: 'linear-gradient(180deg, #F1F5F9 50%, #7BB3F466 100%)' }}>
            <div className="absolute bottom-[-10rem] md:bottom-[-18rem] right-0 opacity-[.6]">
                <img src="/asset/logo_white.svg" className="w-[70%] ml-auto md:w-[560px]" />
            </div>

            <div className={`bg-slate-600 w-full md:w-full h-[250px] md:h-[100vh] block md:sticky top-2`} style={{ backgroundImage: "url('/asset/Testimoni.webp')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} />

            {/* Slider Section */}
            <div className="flex flex-row md:flex-col gap-10 pt-8 pb-12 md:pr-12 w-full px-4 md:px-10 overflow-x-auto">
                {arrComment?.map((obj, idx) => (
                    <div
                        key={idx}
                        className={`flex-shrink-0 md:flex-shrink w-[300px] md:w-[400px] 2xl:w-[500px] 3xl:w-[600px] p-4 md:p-10 rounded-[20px] md:rounded-[35px] text-center backdrop-blur-xs bg-[#ffffff] border border-white relative ${idx % 2 === 0 ? 'md:mr-10 mr-0' : 'md:ml-auto ml-0'}`}
                    >
                        <div className="absolute -top-3 left-8">
                            <img className="w-[80%]" src={idx % 2 === 0 ? "/asset/Icon_blue.png" : "/asset/Icon_red.png"} />
                        </div>
                        <p className="text-sm md:text-base">{obj?.message}</p>
                        <p className="text-sm md:text-base pt-8 md:pt-4 font-medium">{obj?.author}</p>
                    </div>
                ))}
            </div>
        </div>

        <div className="pt-16 md:pt-28" >
            <p className={(lang === 'en' ? 'text-[#48494B] font-normal ' : 'text-[#034694] font-semibold') + ' leading-tight text-center relative'}>
                {lang === 'en' ? (<>
                    <span className="text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center">{'Our '}</span> <CircleEffect
                        setClass={'text-[#034694] text-[32px] md:text-[84px] font-semibold'}
                        setClassDoodle={'-bottom-16 md:-bottom-14 h-[145px] md:h-[140px] w-full left-[-2px] md:left-[-1px]'}
                        text={'benefits'}
                        type="line"
                    />
                </>) : (<>
                    <CircleEffect
                        setClass={'text-[#034694] text-[32px] md:text-[84px] font-semibold mr-1.5 md:mr-6'}
                        setClassDoodle={'-bottom-16 md:-bottom-14 h-[145px] md:h-[140px] w-full left-[-2px] md:left-[-1px]'}
                        text={'benefit'}
                        type="line"
                    /> <span className="text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center">{' yang Kami Tawarkan'}</span>
                </>)}
            </p>
            <div className="pt-12" />
            <CardCarousel
                data={arrBenefit}
                setHeight={mobileView ? '400px' : '580px'}
                clickableCards={false}
                mobileView={mobileView}
                settingDefault={false}
                renderCard={(item, index, isActive) => (
                    <div className="flip-container w-[270px] md:w-[395px] h-[400px] md:h-[600px]">
                        <div className="flip-inner rounded-[30px]">
                            <div className="flip-front flex flex-col  bg-white rounded-[30px] h-[380px] md:h-[500px] " style={{ boxShadow: '0 7px 19px rgba(0 118 255 / 7%)' }}>
                                <div className="bg-slate-600 rounded-t-[30px] w-full h-[270px] md:h-[350px]" style={{ backgroundImage: `url(${item?.image})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />
                                <div className="flex flex-col justify-center gap-4 p-4 md:p-6">
                                    <p className="text-medium font-bold md:text-[22px] truncate-2-lines">{item?.label}</p>
                                    <p className="font-normal text-xs md:text-[15px] truncate-2-lines">{item?.description}</p>
                                </div>
                            </div>
                            <div className="flip-back flex flex-col flex-shrink-0 rounded-[30px] bg-[#034694]  h-[380px] md:h-[500px] absolute top-0" style={{ boxShadow: '0 7px 19px rgba(0 118 255 / 7%)' }}>
                                <div className="rounded-t-[30px] w-full h-[80px] md:h-[150px]" />
                                <div className="flex flex-col justify-end gap-4 p-4 md:p-6">
                                    <p className="text-medium font-bold text-white md:text-[22px]">{item?.label}</p>
                                    <p className="font-normal text-xs md:text-sm text-white md:text-[15px]">{item?.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                onSlideChange={(index) => setCurrentSlide(index)}
                autoPlay={false}
            />
            <div className="md:pb-12" />
        </div>

        <div className="py-20 md:py-28 mt-20" data-aos="fade-down" style={{ backgroundImage: 'linear-gradient(160deg, #7BB3F466 5%, #F1F5F9 20%, #7BB3F466 100%)' }}>
            <p className={(lang === 'en' ? 'text-[#48494B] font-normal ' : 'text-[#EA2427] font-semibold') + 'text-[32px] md:text-[84px] leading-tight text-center'}>
                {lang === 'en' ? (<>
                    <span className="text-[32px] md:text-[84px]">{lang === 'en' ? 'Latest ' : 'Lowongan '}</span>
                    <CircleEffect
                        setClass={'text-[#EA2427] text-[32px] md:text-[84px] font-semibold'}
                        setClassDoodle={'-bottom-14 md:-bottom-4 h-[145px] md:h-[140px] w-[90px] md:w-[240px] left-[-2px] md:left-[-18px]'}
                        text={lang === 'en' ? 'jobs' : 'terbaru'}
                        setColor="#034694"

                    />
                </>)
                    : (<>
                        <CircleEffect
                            setClass={'text-[#EA2427] text-[32px] md:text-[84px] font-semibold'}
                            setClassDoodle={'-bottom-14 h-[145px] md:h-[140px] w-full '}
                            text={lang === 'en' ? 'Latest ' : 'Lowongan '}
                            setColor="#034694"
                            type='line'
                        /> <span className="text-[32px] text-[#48494B] md:text-[84px]">{lang === 'en' ? 'jobs' : 'terbaru'}</span>
                    </>)}
            </p>
            <div className="w-[85%] md:w-[70%] max-w-[1180px] mx-auto pt-10 flex flex-col justify-center items-center">
                <Accordion items={jobListData} isWithID={true} setIsDrawerOpen={setIsDrawerOpen} setDrawerTitle={setDrawerTitle} setJob={setJob} />
                <div className="pt-6">
                    <Link to={`/${lang}/portal`} onClick={() => window.scrollTo(0, 0)} className="bg-[#EA2427] text-white rounded-full py-2 px-6 font-semibold">{Lang(lang, 'explore_jobs')}</Link>
                </div>
            </div>
        </div>

        <div className="pt-16 md:pt-28 mb-24" data-aos="fade-up">
            <p className='text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center'>{Lang(lang, 'life_at')} <b className='text-[#EA2427] font-semibold'>SOPRA</b> </p>
            <div className='flex flex-row flex-wrap items-center justify-center mt-10 mx-auto gap-4 w-[85%] md:w-[70%]'>
                {blogData?.map((obj, idx) =>
                    (idx === 0 || idx % 5 === 0) ?
                        <Link key={obj.blogID} to={`/${lang}/blogs/detail?id=${obj.blogID}`} onClick={() => window.scrollTo(0, 0)} className='relative rounded-[20px] md:rounded-[35px] p-5 text-sm font-normal w-full bg-white' style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                            <div className='h-[200px] md:h-[387px] bg-slate-600 rounded-[20px]'>
                                <img src={baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)} className="w-full h-full object-cover rounded-[20px]" />
                            </div>
                            <div className='flex flex-row items-end justify-between'>
                                <div className='text-[#48494B] p-2'>
                                    <div className="flex flex-row pt-3">
                                        {obj.blogTags && (obj.blogTags?.split(',').map(tag => tag.trim())).map((val, idx) => (
                                            <div key={idx} className='py-1 px-2 mr-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                <p className='text-[11px] md:text-xs'>{val}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <h3 className='pt-2 text-sm md:text-lg font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</h3>
                                    <div className='h-[43px] w-[95%] overflow-hidden'>
                                        <div className="pt-2 truncate-2-lines" dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                    </div>
                                </div>
                                <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                            </div>
                        </Link>
                        :
                        <Link to={`/${lang}/blogs/detail?id=${obj.blogID}`} onClick={() => window.scrollTo(0, 0)} class='flex flex-row rounded-[20px] md:rounded-[30px] mb-4 text-left text-sm md:text-lg font-normal w-full md:w-[49%] h-[200px] md:h-[263px] bg-white' style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                            <div class='rounded-s-[20px] md:rounded-s-[30px] bg-slate-600 w-[60%] md:w-[70%] h-full' style={{ backgroundImage: `url('${baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                            <div class='p-2 pr-4 flex flex-col items-end gap-2 justify-between w-full'>
                                <div class='flex flex-col'>
                                    <div className="px-3 flex flex-row pt-1 pb-2 md:pt-5 gap-2">
                                        {<div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                            <p className='text-[11px] md:text-xs'>{obj.blogTags?.split(',').map(tag => tag.trim())[0]}</p>
                                        </div>}
                                        {((obj.blogTags?.split(',').map(tag => tag.trim())).length > 1 &&
                                            <div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                <p className='text-[11px] md:text-xs'>+{(obj.blogTags?.split(',').map(tag => tag.trim())).length - 1}</p>
                                            </div>)}
                                    </div>
                                    <p className='pl-3 pt-0 md:pt-2 text-[#48494B] font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</p>
                                    <div className='w-[95%]'>
                                        <div className='pl-3 pt-2 text-xs truncate-2-lines' dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                    </div>
                                </div>
                                <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                            </div>
                        </Link>
                )}
            </div>
            <div className="flex justify-center">
                {lengthBlogData > 3 && <Link to={`/${lang}/blogs`} onClick={() => window.scrollTo(0, 0)} className="bg-[#EA2427] text-white rounded-full mt-4 py-1 px-4 cursor-pointer font-semibold">{Lang(lang, 'read_more')}</Link>}
            </div>
        </div>

        <JobDrawer
            isOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            title={drawerTitle}
            job={jobData}
        />
        {/* {renderModal()} */}
    </>)
}

export default Home;